export default __webpack_public_path__ + "static/media/tab_6.61023383.png";